import { getFactors } from '../actions/factors'

const FactorCorrelationsStore = {
  getInitialState() {
    return []
  },

  reset(_, { correlations }) {
    return correlations
  },

  register() {
    return {
      [getFactors]: this.reset
    }
  }
}

export default FactorCorrelationsStore



// WEBPACK FOOTER //
// ./src/domains/factor-correlations.js